import { property as c } from "./index-Ba2D8NOp.js";
import { d as u, D as p, m as h } from "./abstract-base-DlmRC3qm-BIlD7-mG.js";
import { a as m } from "./lifecycle-decorators-CUsT9aHq-Dtp3uB6c.js";
import { t as l } from "./beacon-primitive-ChVMWFlW-Df2Js5lw.js";
import { N as B } from "./query-assigned-DZ4JAxBy-BopcW0Vc.js";
import { u as y } from "./utils-BSj5iT7c-dU4w2_Zv.js";
var d = Object.defineProperty, f = Object.getOwnPropertyDescriptor, a = (r, o, t, n) => {
  for (var e = n > 1 ? void 0 : n ? f(o, t) : o, s = r.length - 1, i; s >= 0; s--)
    (i = r[s]) && (e = (n ? i(o, t, e) : i(e)) || e);
  return n && e && d(o, t, e), e;
};
const F = () => function(r) {
  let o = class extends r {
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-input - emits when a standard input event would be fired
     */
    emitInput(t, n) {
      p(this, h.INPUT, !!this.onBeaconInput && this.onBeaconInput(t, n));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-change - emits when a standard change event would be fired
     */
    emitChange(t, n) {
      p(this, h.CHANGE, !!this.onBeaconChange && this.onBeaconChange(t, n));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-focus - emits when a beacon form component receives focus
     */
    emitFocus(t, n) {
      p(this, h.FOCUS, !!this.onBeaconFocus && this.onBeaconFocus(t, n));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-blur - emits when a beacon form component loses focus
     */
    emitBlur(t, n) {
      p(this, h.BLUR, !!this.onBeaconBlur && this.onBeaconBlur(t, n));
    }
    /**
     * TODO: No need
     * @param event
     * @event {BeaconEvents} beacon-event-mousedown - emits when a mousedown event would be fired
     */
    emitMousedown(t) {
      p(this, h.MOUSEDOWN, !!this.onBeaconMousedown && this.onBeaconMousedown());
    }
  };
  return a([
    c({ type: Function })
  ], o.prototype, "onBeaconChange", 2), a([
    c({ type: Function })
  ], o.prototype, "onBeaconBlur", 2), a([
    c({ type: Function })
  ], o.prototype, "onBeaconInput", 2), a([
    c({ type: Function })
  ], o.prototype, "onBeaconFocus", 2), a([
    c({ type: Function })
  ], o.prototype, "onBeaconMousedown", 2), o = a([
    m("FormEvents")
  ], o), o;
};
var g = Object.defineProperty, v = (r, o, t, n) => {
  for (var e = void 0, s = r.length - 1, i; s >= 0; s--)
    (i = r[s]) && (e = i(o, t, e) || e);
  return e && g(o, t, e), e;
};
class C extends l(u, F()) {
  static get formAssociated() {
    return !0;
  }
  constructor() {
    super(), y ? this.internals = null : this.internals = this.attachInternals ? this.attachInternals() : null;
  }
  /**
   * Implement `ElementInternals.setValidity()` with default values.
   * @param flags Custom validation flags.
   * @param message Error message used in validation.
   * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
   */
  setValidity(o, t, n = this.formAnchor) {
    this.internals && this.internals.setValidity(o, t, n);
  }
}
v([
  B(".form-anchor")
], C.prototype, "formAnchor");
export {
  C
};
